import React, { useState, Component, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Redirect, Link } from "react-router-dom";
import { Divider, Icon } from "@material-ui/core";

import MonetizationOnIcon from '@material-ui//icons/MonetizationOn';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import HomeIcon from '@material-ui/icons/Home';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import StarIcon from '@material-ui/icons/Star';

//importing files

// import aboutusImg from "../../../assets/images/Aboutus/boris-misevic-HofOYDPOIdA-unsplash.jpg";

// MUI Components
import {
  Grid,
  Typography,
} from "@material-ui/core";
import AccountCard from "../../../Components/Account-Card/AccountCard";

export default function MyAccountMainPage() {
  const classes = useStyles();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 12 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} style={{color:'grey'}} color="inherit" to="/">
            Home
          </Link>
          <Typography color="textPrimary">My Account </Typography>
        </Breadcrumbs>

        <div>
          <Grid container spacing={1} style={{ margin: "0px 0px 0px 0px" }}>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <AccountCard
                link="/settings"
                title="Personal Information"
                icon={<AccountCircleIcon fontSize="large" className={classes.iconHover} />} />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <AccountCard
                link="/subscribed/stores"
                title="Subscribed Stores"
                icon={<HomeIcon fontSize="large" className={classes.iconHover} />} />

            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <AccountCard link="/orders"
                title="Orders History"
                icon={<ReceiptIcon fontSize="large" className={classes.iconHover} />} />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <AccountCard link="/wishlist"
                title="My Wishlist"
                icon={<ThumbUpIcon fontSize="large" className={classes.iconHover} />} />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <AccountCard link="/reviews"
                title="My Reviews"
                icon={<StarIcon fontSize="large" className={classes.iconHover} />} />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <AccountCard link="/reportSystemProblem"
                title="Report a Problem"
                icon={<MonetizationOnIcon fontSize="large" className={classes.iconHover} />} />
            </Grid>
          </Grid>
        </div>


      </div>
    </div>
  );
}
